import type React from 'react';

import type { ActiveView } from './constants';

export type ViewComponent = React.ComponentType;

export type ViewMap = Partial<Record<ActiveView, ViewComponent>>;

interface AIAssistantViewRouterProps {
	activeView: ActiveView;
	viewMap: ViewMap;
}

const AIAssistantViewRouter: React.FC<AIAssistantViewRouterProps> = ({ activeView, viewMap }) => {
	const Component = viewMap[activeView];
	if (!Component) return null;

	return <Component />;
};

export default AIAssistantViewRouter;
